import { LauncherMessages, TranslationLauncherMessages } from "../interfaces";

export const messages: TranslationLauncherMessages = {
  [LauncherMessages.launcherSelectModule]: "Seleccione el módulo para continuar",
  [LauncherMessages.launcherGreeting]: "Hola, {{name}}",
  [LauncherMessages.launcherActiveCount]: "{{count}} módulos activos",
  [LauncherMessages.launcherContactUs]: "Contáctenos para desbloquear",
  [LauncherMessages.launcherNoAccessTooltip]: "Solicite acceso al administrador de esta empresa",
  [LauncherMessages.launcherModuleDescTech]: "Control y gestión del hormigón por el dominio de la tecnología",
  [LauncherMessages.launcherModuleDescFleet]: "Aumente la productividad con rastreo para su hormigonera",
  [LauncherMessages.launcherModuleDescDispatch]: "Simplificando por completo el proceso logístico del hormigón",
  [LauncherMessages.launcherModuleDescCustomer]: "Aplicación del cliente con visión macro de la obra",
  [LauncherMessages.launcherModuleDescBi]: "Business intelligence alineado a la gestión del hormigón",
  [LauncherMessages.launcherModuleDescCrm]: "Gestión total de contratos de forma simple y transparente",
  [LauncherMessages.launcherModuleDescBilling]: "Facturación con apenas algunos clics",
  [LauncherMessages.launcherModuleDescFinances]: "Control y gestión financiera del hormigón",
  [LauncherMessages.launcherModuleDescPurchase]: "Entrada de notas, combustible y stock de materia prima",
  [LauncherMessages.launcherModuleDescBatch]: "Automatización del proceso de pesaje",
  [LauncherMessages.launcherModuleDescReports]: "Informes e indicadores de la operación del hormigón",
  [LauncherMessages.launcherModuleDescBackoffice]: "Backoffice: compras, finanzas y facturación",
  [LauncherMessages.launcherModuleDescFmx]: "Gestión de flota y operación de hormigón",
  [LauncherMessages.launcherModuleDescDriver]: "App del conductor/bombista",
  [LauncherMessages.launcherModuleDescFmxSuite]: "Gestión (FMX) y app del conductor (DRIVER)",
  [LauncherMessages.launcherModuleDescIdentity]: "Gestión de identidad, accesos y permisos de la suite Topcon",
  [LauncherMessages.launcherModuleTaglineCrm]: "Contratos bajo control, del presupuesto a la firma.",
  [LauncherMessages.launcherModuleTaglineBilling]: "Facture más rápido sin burocracia.",
  [LauncherMessages.launcherModuleTaglineFinances]: "Su salud financiera bajo control total.",
  [LauncherMessages.launcherModuleTaglinePurchase]: "Reduzca costos con compras inteligentes.",
  [LauncherMessages.launcherModuleTaglineBatch]: "Pesaje automático, mezcla bajo control.",
  [LauncherMessages.launcherUpsellNote]:
    "Este módulo no está contratado. Póngase en contacto con su consultor Topcon.",
  [LauncherMessages.launcherLicenseWarning]:
    "Su licencia vence en {{count}} días. Contacte al área financiera para renovar.",
  [LauncherMessages.launcherLicenseExpiredTitle]: "Licencia vencida",
  [LauncherMessages.launcherLicenseExpiredText]:
    "La licencia de su empresa ha vencido. Contacte al área financiera para restablecer el acceso.",
  [LauncherMessages.launcherLoading]: "Cargando sus módulos...",
  [LauncherMessages.launcherLoadError]: "No se pudieron cargar sus módulos. Inténtelo de nuevo."
};
